import React, { useState, useEffect, useRef } from "react"
import axios from "axios"
import { useParams, useSearchParams } from "react-router-dom"
import { Container, Row, Col, Button, Card, CardBody, Input } from "reactstrap"
import { InputText } from "primereact/inputtext"
import { Checkbox } from "primereact/checkbox"
import { Dropdown } from "primereact/dropdown"
import { Calendar } from "primereact/calendar"
import { Dialog } from "primereact/dialog"
import { Toast } from "primereact/toast"
import { Link } from "react-router-dom"
import { InputTextarea } from "primereact/inputtextarea"
import { FileUpload } from "primereact/fileupload"
import { useNavigate } from "react-router-dom"
import { triggerAlert } from "utils/CommonFunctions"
import { TreeSelect } from "primereact/treeselect"
import moment from "moment"

const ContactEditForm = () => {
  // const { id } = useParams();
  const toast = useRef(null)
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const id = searchParams.get("id")

  // State declarations
  const [firstName, setFirstName] = useState("") // Modified: Added firstName
  const [middleName, setMiddleName] = useState("") // Modified: Added middleName
  const [lastName, setLastName] = useState("") // Modified: Added lastName
  const [email, setEmail] = useState("")
  const [phno, setPhno] = useState("")
  const [designation, setDesignation] = useState("")
  const [selectedCompany, setSelectedCompany] = useState(null)
  const [companies, setCompanies] = useState([])
  const [selectedDepartment, setSelectedDepartment] = useState(null)
  const [departments, setDepartments] = useState([])
  const [selectedPerson, setSelectedPerson] = useState(null)
  const [persons, setPersons] = useState([])
  const [userid1, setUserid1] = useState("")
  const [watchWord, setWatchWord] = useState("")
  const [showPassword, setShowPassword] = useState(false)
  const [visible, setVisible] = useState(false)
  const [street1, setStreet1] = useState("")
  const [street2, setStreet2] = useState("")
  const [selectedCity, setSelectedCity] = useState(null)
  const [cities, setCities] = useState([])
  const [selectedState, setSelectedState] = useState(null)
  const [states, setStates] = useState([])
  const [selectedCountry, setSelectedCountry] = useState(null)
  const [countries, setCountries] = useState([])
  const [postalCode, setPostalCode] = useState("")
  const [selectedLabel, setSelectedLabel] = useState(null)
  const [address, setAddress] = useState("")
  const [createdBy, setCreatedBy] = useState("")
  const [createdAt, setCreatedAt] = useState("")
  const [updatedAt, setUpdatedAt] = useState("")
  const [uniqueUserId, setUniqueUserId] = useState("")
  const [popchecked2, setPopchecked2] = useState(false)
  const [notes, setNotes] = useState("")
  const [errors, setErrors] = useState({
    firstName: "", // Modified: Changed from fullname to firstName
    email: "",
    phno: "",
    watchWord: "",
  })

  useEffect(() => {
    const userInfo = JSON.parse(sessionStorage.getItem("user-info"))
    if (userInfo && userInfo.user_details) {
      setUniqueUserId(userInfo.user_details.unique_user_id)
    }
  }, [])

  const [labels, setLabels] = useState([])

  const fetchLabels = async () => {
    try {
      const response = await axios.get("/api/v1/get-all-address-label/")
      const labelsData = response?.data?.results
      setLabels(
        labelsData?.map(item => ({
          name: item?.address_label,
          id: item?.id,
        }))
      )
    } catch (error) {
      console.error("Error fetching labels:", error)
      triggerAlert("error", "Error", "Failed to fetch address labels")
      setLabels([])
    }
  }

  // const labels = [
  //   { name: "Work from Office (WFO)", code: "WORK" },
  //   { name: "Work from Home (WFH)", code: "HOME" },
  //   { name: "Work from Remote (WFR)", code: "REMOTE" }
  // ];

  // API calls
  const getCompanyData = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-companies/`)
      const transformedData = response.data.results.map(company => ({
        name: company.company_name,
        id: company.company_id,
      }))
      setCompanies(transformedData)
    } catch (error) {
      //console.error('Error fetching company data:', error);
      triggerAlert("error", "Error", "Failed to fetch companies")
    }
  }

  const getDepartmentData = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-departments/`)
      const transformedData = response.data.results.map(department => ({
        name: department.name,
        id: department.department_id,
      }))
      setDepartments(transformedData)
    } catch (error) {
      //console.error('Error fetching department data:', error);
      triggerAlert("error", "Error", "Failed to fetch departments")
    }
  }

  const [treeCategories, setTreeCategories] = useState([])
  const [selectedCategoryKey, setSelectedCategoryKey] = useState(null)

  const transformCategoriesToTree = categories => {
    const buildTree = category => ({
      key: category.category_id,
      label: category.name,
      data: category,
      children: category.subcategories
        ? category.subcategories.map(buildTree)
        : [],
    })

    return categories.map(buildTree)
  }

  // Transform groups to tree structure
  const transformGroupsToTree = groups => {
    const buildTree = group => ({
      key: group.group_id,
      label: group.name,
      data: group,
      children: group.subgroups ? group.subgroups.map(buildTree) : [],
    })

    return groups.map(buildTree)
  }

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-categories/`)
      if (response.data && response.data.results) {
        const treeData = transformCategoriesToTree(response.data.results)
        setTreeCategories(treeData)
      }
    } catch (error) {
      //console.error('Error fetching categories:', error);
      triggerAlert("error", "Error", "Failed to fetch categories")
    }
  }

  const [selectedGroupKey, setSelectedGroupKey] = useState(null)
  const [groupitem, setGroupitem] = useState([])

  const getgroupsitemsub = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-groups/`)
      if (response.data) {
        const treeData = transformGroupsToTree(response.data.results)
        // //console.log('Tree Data:', treeData); // Log the tree data
        setGroupitem(treeData)
      }
    } catch (error) {
      //console.error('Error fetching groups:', error);
      triggerAlert("error", "Error", "Failed to fetch groups")
    }
  }

  useEffect(() => {
    fetchLabels()
    fetchCategories()
    getgroupsitemsub()
  }, [])

  // Helper function to find a category by name in a tree structure
  const findCategoryByName = (categories, name) => {
    for (const category of categories) {
      if (category.data.name === name) {
        return category
      }
      if (category.children) {
        const foundInChildren = findCategoryByName(category.children, name)
        if (foundInChildren) {
          return foundInChildren
        }
      }
    }
    return null
  }

  // Helper function to find a group by name in a tree structure
  const findGroupByName = (groups, name) => {
    for (const group of groups) {
      if (group.data.name === name) {
        return group
      }
      if (group.children) {
        const foundInChildren = findGroupByName(group.children, name)
        if (foundInChildren) {
          return foundInChildren
        }
      }
    }
    return null
  }

  const getCountryData = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-countries/`)
      const transformedData = response.data.results.map(country => ({
        name: country.name,
        code: country.country_id,
      }))
      setCountries(transformedData)
    } catch (error) {
      //console.error('Error fetching country data:', error);
      triggerAlert("error", "Error", "Failed to fetch countries")
    }
  }

  const getStateData = async country_id => {
    try {
      const response = await axios.get(
        `/api/v1/get-all-states/?country_id=${country_id}`
      )
      const transformedData = response.data.results.map(state => ({
        name: state.name,
        code: state.state_id,
      }))
      setStates(transformedData)
    } catch (error) {
      //console.error('Error fetching state data:', error);
      triggerAlert("error", "Error", "Failed to fetch states")
    }
  }

  const getCityData = async stateId => {
    try {
      const response = await axios.get(
        `/api/v1/get-all-cities/?state_id=${stateId}`
      )
      const transformedData = response.data.results.map(city => ({
        name: city.name,
        code: city.city_id,
      }))
      setCities(transformedData)
    } catch (error) {
      //console.error('Error fetching city data:', error);
      triggerAlert("error", "Error", "Failed to fetch cities")
    }
  }

  const getRelatedPersons = async () => {
    try {
       const response = await axios.get(`/api/v1/get-all-hiring-managers/?exclude_user_id=${id}&status=Active`);
      const transformedData = response.data.results.map(city => ({
        name: `${city.first_name || ""} ${city.middle_name || ""} ${
          city.last_name || ""
        }`,
        id: city.id,
      }))
      setPersons(transformedData)
    } catch (error) {
      // //console.log("Failed to fetch related persons", error);
      triggerAlert("error", "Error", "Failed to fetch related persons")
    }
  }

  useEffect(() => {
    // //console.log("relateddddddddddddddddddddddd",persons)
    getRelatedPersons()
  }, [])

  const handlePopupCheckbox2 = e => {
    setPopchecked2(e.target.checked)
    // //console.log("Checkbox State:", e.checked);
  }

  const getContactData = async () => {
    try {
      const response = await axios.get(`/api/v1/contacts/${id}/`)
      const contactData = response.data

      setFirstName(contactData.first_name || "")
      setMiddleName(contactData.middle_name || "")
      setLastName(contactData.last_name || "")
      setEmail(contactData.email)
      setPhno(contactData.phone_number)
      setDesignation(contactData.job_title)
      setUserid1(contactData.user_id)
      setWatchWord(contactData.watch_word || "")
      setCreatedBy(contactData.created_by_name || "")
      setCreatedAt(
      contactData.created_at
        ? moment(contactData.created_at).toDate()
        : ""
    )
    setUpdatedAt(
      contactData.updated_at
        ? moment(contactData.updated_at).toDate()
        : ""
    )
      setStreet1(contactData.street_address || "")
      setStreet2(contactData.street_address_line_2 || "")
      setPostalCode(contactData.pincode || "")
      setAddress(contactData.full_address || "")
      setPopchecked2(contactData.private)

      if (contactData.category_name) {
        const category = findCategoryByName(
          treeCategories,
          contactData.category_name
        )
        // //console.log('Found Category:', category);
        if (category) {
          setSelectedCategoryKey(category.key)
        } 
        // else {
        //   //console.error('Category not found:', contactData.category_name);
        //   triggerAlert("error", "Error", "Category not found")
        // }
      }

      if (contactData.groups_name) {
        const group = findGroupByName(groupitem, contactData.groups_name)
        // //console.log('Found Group:', group);
        if (group) {
          setSelectedGroupKey(group.key)
        } else {
          //console.error('Group not found:', contactData.groups_name);
        }
      }

      if (contactData.company && contactData.company_name) {
        setSelectedCompany({
          name: contactData.company_name,
          id: contactData.company,
        })
      } else {
        setSelectedCompany(null)
      }

      if (contactData.department && contactData.department_name) {
        setSelectedDepartment({
          name: contactData.department_name,
          id: contactData.department,
        })
      } else {
        setSelectedDepartment(null)
      }

      if (contactData.country && contactData.country_name) {
        setSelectedCountry({
          name: contactData.country_name,
          code: contactData.country,
        })
        if (contactData.state && contactData.state_name) {
          await getStateData(contactData.country)
          setSelectedState({
            name: contactData.state_name,
            code: contactData.state,
          })
          if (contactData.city && contactData.city_name) {
            await getCityData(contactData.state)
            setSelectedCity({
              name: contactData.city_name,
              code: contactData.city,
            })
          } else {
            setSelectedCity(null)
          }
        } else {
          setSelectedState(null)
          setSelectedCity(null)
        }
      } else {
        setSelectedCountry(null)
        setSelectedState(null)
        setSelectedCity(null)
      }

      if (contactData.related_person_name) {
        const person = persons.find(
          p =>
            p.name.trim().toLowerCase() ===
            contactData.related_person_name.trim().toLowerCase()
        )
        if (person) {
          setSelectedPerson(person)
          ////console.log("Selected Person:", person);
        } else {
          const fallbackPerson = {
            name: contactData.related_person_name,
            id: contactData.related_person,
          }
          setSelectedPerson(fallbackPerson)
          //console.log("Selected Person (fallback):", fallbackPerson);
        }
      } else {
        setSelectedPerson(null)
        //console.log("No related person found in contact data.");
      }

      if (contactData.label) {
        // Find the label object in the labels array by name or id
        const labelObj = labels.find(
          lbl => lbl.name === contactData.label || lbl.id === contactData.label
        ) || { name: contactData.label }
        setSelectedLabel(labelObj)
      } else {
        setSelectedLabel(null)
      }
    } catch (error) {
      //console.error("Error fetching contact data:", error);
      triggerAlert("error", "Error", "Failed to fetch contact data")
    }
  }

  const validateForm = () => {
    let isValid = true
    const newErrors = {
      firstName: "",
      middleName: "",
      lastName: "",
      email: "",
      userid1: "",
      phno: "",
      watchWord: "",
    }

    // Validate Full Name
    if (!firstName.trim()) {
      newErrors.firstName = { message: "First name is required." }
      isValid = false
    } else if (!/^[a-zA-Z]+$/.test(firstName)) {
      newErrors.firstName = {
        message: "First name should contain only alphabets.",
      }
      isValid = false
    } else if (firstName?.length > 30) {
      newErrors.firstName = {
        message: "First name should not exceed 30 characters.",
      }
      isValid = false
    }

    // Validate Middle Name
    if (middleName && !/^[a-zA-Z]+$/.test(middleName)) {
      newErrors.middleName = {
        message: "Middle name should contain only alphabets.",
      }
      isValid = false
    } else if (middleName && middleName?.length > 30) {
      newErrors.middleName = {
        message: "Middle name should not exceed 30 characters.",
      }
      isValid = false
    }

    if (lastName && !/^[a-zA-Z]+$/.test(lastName)) {
      newErrors.lastName = {
        message: "Last name should contain only alphabets.",
      }
      isValid = false
    } else if (lastName && lastName?.length > 30) {
      newErrors.lastName = {
        message: "Last name should not exceed 30 characters.",
      }
      isValid = false
    }

    // Validate Email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!email.trim()) {
      newErrors.email = { message: "Email is required." }
      isValid = false
    } else if (!emailRegex.test(email)) {
      newErrors.email = { message: "Please enter a valid email address." }
      isValid = false
    }

    // Validate Phone Number
    const phoneRegex = /^[6-9]\d{0,9}$/
    if (phno && !phoneRegex.test(phno)) {
      newErrors.phno = {
        message:
          "Phone number should start with a digit from 6 to 9 and max 10 digits.",
      }
      isValid = false
    }
    // Validate Username
    const usernameRegex = /^[a-z]+$/
    if (!usernameRegex.test(userid1)) {
      newErrors.userid1 = {
        message: "Only lowercase letters are allowed. No numbers or spaces.",
      }
      isValid = false
    } else if (userid1?.length > 30) {
      newErrors.userid1 = { message: "Username cannot exceed 30 characters." }
      isValid = false
    }

    // Validate Password
    if (watchWord.trim()) {
      if (watchWord?.length < 8) {
        newErrors.watchWord = {
          message: "Password must be at least 8 characters.",
        }
        isValid = false
      } else if (watchWord?.length > 25) {
        newErrors.watchWord = {
          message: "Password must not exceed 25 characters.",
        }
        isValid = false
      }
    }

    setErrors(newErrors)
    return isValid
  }

  const handleEditContact = async () => {
    if (!validateForm()) {
      return
    }

    try {
      const response = await axios.patch(`/api/v1/contacts/${id}/`, {
        first_name: firstName,
        middle_name: middleName,
        last_name: lastName,
        email: email,
        phone_number: phno,
        job_title: designation,
        company: selectedCompany?.id,
        department: selectedDepartment?.id,
        category: selectedCategoryKey,
        group: selectedGroupKey,
        country_name: selectedCountry?.name,
        state_name: selectedState?.name,
        city_name: selectedCity?.name,
        street_address: street1,
        street_address_line_2: street2,
        pincode: postalCode,
        country: selectedCountry?.code,
        state: selectedState?.code,
        city: selectedCity?.code,
        related_person: selectedPerson?.id,
        label: selectedLabel?.id,
        private: popchecked2,
        user_notes: notes,
        user_id: userid1,
        password: watchWord,
      })

      triggerAlert("success", "Success", "Contact updated successfully")
      navigate("/contacts-allactive")
    } catch (error) {
      //console.error('Error updating contact:', error);
      triggerAlert(
        "error",
        "Error",
        error.response.data?.error || "Failed to update contact"
      )
      navigate("/contacts-allactive")
    }
  }

  useEffect(() => {
    getCompanyData()
    getDepartmentData()
    getCountryData()
  }, [])


  useEffect(() => {
    if (
      persons?.length > 0 &&
      treeCategories?.length > 0 &&
      groupitem?.length > 0
    ) {
      getContactData()
    } else {
      getContactData()
    }
  }, [persons, treeCategories, groupitem])

  useEffect(() => {
    setStates([]) // Clear states
    setSelectedState(null) // Clear selected state
    setCities([]) // Clear cities
    setSelectedCity(null) // Clear selected city
    if (selectedCountry) {
      getStateData(selectedCountry.code)
    }
  }, [selectedCountry])

  useEffect(() => {
    if (selectedState) {
      getCityData(selectedState.code)
    } else {
      setCities([])
      setSelectedCity(null)
    }
  }, [selectedState])

  const updateAddress = () => {
    const updatedAddress = [
      street1,
      street2,
      selectedCountry?.name,
      selectedState?.name,
      selectedCity?.name,
      postalCode,
      selectedLabel?.name,
    ].filter(part => part && part.trim() !== "")
    const formattedAddress = updatedAddress
      .map((part, index) =>
        index < updatedAddress?.length - 1 ? `${part},` : part
      )
      .join("\n")
    // //console.log('Formatted address:', formattedAddress);
    setAddress(formattedAddress)
  }

  const handleCancel = () => {
    navigate("/contacts-allactive")
  }

  const [initialAddressValues, setInitialAddressValues] = useState({
    street1: "",
    street2: "",
    selectedCountry: null,
    selectedState: null,
    selectedCity: null,
    postalCode: "",
    selectedLabel: null,
  })

  const handleOpenDialog = () => {
    setInitialAddressValues({
      street1,
      street2,
      selectedCountry,
      selectedState,
      selectedCity,
      postalCode,
      selectedLabel,
    })
    setVisible(true)
  }

  useEffect(() => {
    updateAddress()
  }, [
    street1,
    street2,
    selectedCity,
    selectedState,
    selectedCountry,
    postalCode,
    selectedLabel,
  ])

  return (
    <React.Fragment>
      <div className="page-content create-ajob">
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={6}>
                <h1 className="page-title">Edit Contact</h1>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">
                    Edit contact details and update the records.
                  </li>
                </ol>
              </Col>
              <Col md={6}>
                <div className="d-flex justify-content-end">
                  {/* <Toast ref={toast} />
                  <Link to="/contacts-allactive"> */}
                  <Button
                    color="success"
                    className="me-2"
                    onClick={handleEditContact}
                  >
                    <i className="pi pi-save me-1"></i> Save
                  </Button>
                  {/* </Link>
                  <Link to="/contacts-allactive"> */}
                  <Button
                    color="primary"
                    className="btn btn-primary me-2 cancel-outlinebtn"
                    onClick={handleCancel}
                  >
                    <i className="pi pi-times me-1"></i> Cancel
                  </Button>
                  {/* </Link> */}
                </div>
              </Col>
            </Row>
          </div>

          <Row>
            <Col xl={6}>
              <Card className="bg-form">
                <CardBody>
                  <h4 className="card-title mb-2">Basic Information</h4>
                  <Row>
                    <Col xl={12}>
                      <div>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label htmlFor="firstName">
                              First Name<span style={{ color: "red" }}>*</span>
                            </label>
                          </Col>
                          <Col xl={9}>
                            <InputText
                              id="firstName"
                              value={firstName}
                              onChange={e => setFirstName(e.target.value)}
                              className="w-full"
                            />
                            {errors.firstName && (
                              <small
                                id="firstNameHelp"
                                className="form-text text-danger"
                              >
                                {errors.firstName.message}
                              </small>
                            )}
                          </Col>
                        </Row>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label htmlFor="middleName">Middle Name</label>
                          </Col>
                          <Col xl={9}>
                            <InputText
                              id="middleName"
                              value={middleName}
                              onChange={e => setMiddleName(e.target.value)}
                              className="w-full"
                            />
                            {errors.middleName && (
                              <small
                                id="middleNameHelp"
                                className="form-text text-danger"
                              >
                                {errors.middleName.message}
                              </small>
                            )}
                          </Col>
                        </Row>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label htmlFor="lastName">Last Name</label>
                          </Col>
                          <Col xl={9}>
                            <InputText
                              id="lastName"
                              value={lastName}
                              onChange={e => setLastName(e.target.value)}
                              className="w-full"
                            />
                            {errors.lastName && (
                              <small
                                id="lastNameHelp"
                                className="form-text text-danger"
                              >
                                {errors.lastName.message}
                              </small>
                            )}
                          </Col>
                        </Row>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label htmlFor="email">
                              Email<span style={{ color: "red" }}>*</span>
                            </label>
                          </Col>
                          <Col xl={9}>
                            <InputText
                              id="email"
                              value={email}
                              onChange={e => setEmail(e.target.value)}
                              className="w-full"
                            />
                            {errors.email && (
                              <small
                                id="emailHelp"
                                className="form-text text-danger"
                              >
                                {errors.email.message}
                              </small>
                            )}
                          </Col>
                        </Row>

                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label htmlFor="phno">Phone Number</label>
                          </Col>
                          <Col xl={9}>
                            <InputText
                              id="phno"
                              value={phno}
                              onChange={e => setPhno(e.target.value)}
                              className="w-full"
                            />
                            {errors.phno && (
                              <small
                                id="phnoHelp"
                                className="form-text text-danger"
                              >
                                {errors.phno.message}
                              </small>
                            )}
                          </Col>
                        </Row>

                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label htmlFor="designation">Designation</label>
                          </Col>
                          <Col xl={9}>
                            <InputText
                              id="designation"
                              value={designation}
                              onChange={e => setDesignation(e.target.value)}
                              className="w-full"
                            />
                          </Col>
                        </Row>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label htmlFor="company">Company</label>
                          </Col>
                          <Col xl={9}>
                            <Dropdown
                              value={selectedCompany}
                              options={companies}
                              onChange={e => setSelectedCompany(e.value)}
                              optionLabel="name"
                              placeholder="Select a Company"
                              className="w-full bgclr"
                            />
                          </Col>
                        </Row>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label htmlFor="department">Department</label>
                          </Col>
                          <Col xl={9}>
                            <Dropdown
                              value={selectedDepartment}
                              options={departments}
                              onChange={e => setSelectedDepartment(e.value)}
                              optionLabel="name"
                              placeholder="Select a Department"
                              className="w-full bgclr"
                            />
                          </Col>
                        </Row>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label htmlFor="username">Username</label>
                          </Col>
                          <Col xl={9}>
                            <InputText
                              id="username"
                              value={userid1}
                              onChange={e => setUserid1(e.target.value)}
                              className="w-full"
                            />
                            {errors.userid1 && (
                              <small
                                id="usernameHelp"
                                className="form-text text-danger"
                              >
                                {errors.userid1.message}
                              </small>
                            )}
                          </Col>
                        </Row>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label htmlFor="password">Password</label>
                          </Col>
                          <Col xl={9}>
                            <div
                              className="p-field"
                              style={{ position: "relative" }}
                            >
                              <InputText
                                id="password"
                                type={showPassword ? "text" : "password"}
                                value={watchWord}
                                onChange={e => setWatchWord(e.target.value)}
                                className="w-full"
                                style={{ paddingRight: "2rem" }}
                              />
                              <i
                                className={
                                  showPassword ? "pi pi-eye" : "pi pi-eye-slash"
                                }
                                style={{
                                  position: "absolute",
                                  right: "10px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  color: "#6c757d",
                                  cursor: "pointer",
                                }}
                                onClick={() => setShowPassword(!showPassword)}
                              />
                              {errors.watchWord && (
                                <small
                                  id="passwordHelp"
                                  className="form-text text-danger"
                                >
                                  {errors.watchWord.message}
                                </small>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            <Col xl={6}>
              <Card className="bg-form">
                <CardBody>
                  <h4 className="card-title mb-2">Contact Details</h4>
                  <Row>
                    <Col xl={12}>
                      <div>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label htmlFor="person">Related Person</label>
                          </Col>
                          <Col xl={9}>
                            <Dropdown
                              value={selectedPerson}
                              options={persons}
                              onChange={e => setSelectedPerson(e.value)}
                              optionLabel="name"
                              placeholder="Select a Person"
                              className="w-full bgclr"
                            />
                          </Col>
                        </Row>
                        <Row className="mt-2 align-items-center">
                          <Col lg={3}>
                            <label htmlFor="category">Categories</label>
                          </Col>
                          <Col xl={9}>
                            <TreeSelect
                              value={selectedCategoryKey}
                              onChange={e => {
                                setSelectedCategoryKey(e.value)
                              }}
                              options={treeCategories}
                              // optionLabel="label"
                              // optionValue="key"
                              placeholder="Select Category"
                              className="w-full bgclr"
                            />
                          </Col>
                        </Row>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label htmlFor="group">Groups</label>
                          </Col>
                          <Col xl={9}>
                            <TreeSelect
                              value={selectedGroupKey}
                              onChange={e => setSelectedGroupKey(e.value)}
                              options={groupitem}
                              // optionLabel="label"
                              // optionValue="key"
                              placeholder="Select Group"
                              className="w-full activejobdrop"
                            />
                          </Col>
                        </Row>

                        <Row className="mt-2 align-items-center">
                          <Col lg={6}>
                            <Row>
                              <Col xl={6}>
                                <label htmlFor="userids" className="block mb-2">
                                  UserIDs
                                </label>
                              </Col>
                              <Col xl={6}>
                                <InputText
                                  id="userid"
                                  value={uniqueUserId}
                                  disabled
                                  className="w-full"
                                />
                              </Col>
                            </Row>
                          </Col>
                          <Col lg={6}>
                            <Row>
                              <Col xl={12}>
                                <input
                                  id="jobType"
                                  type="checkbox"
                                  className="me-2"
                                  onChange={handlePopupCheckbox2}
                                  checked={popchecked2}
                                />
                                <label htmlFor="jobType">Private</label>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        {/* <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label htmlFor="attachment">Attach Document</label>
                          </Col>
                          <Col xl={9}>
                            <FileUpload name="demo[]" url="/api/upload" multiple accept="image/*" maxFileSize={1000000} mode="basic" />
                          </Col>
                        </Row> */}
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label htmlFor="address">Address</label>
                          </Col>
                          <Col xl={9}>
                            <div
                              className="p-field companie-add"
                              style={{ position: "relative" }}
                            >
                              <InputTextarea
                                id="address"
                                value={address}
                                readOnly
                                onChange={e => setAddress(e.target.value)}
                                rows={3}
                                cols={30}
                                className="w-full"
                                style={{ paddingRight: "2rem", resize: "none" }}
                              />
                              <i
                                className="pi pi-pencil"
                                style={{
                                  position: "absolute",
                                  right: "10px",
                                  top: "70%",
                                  transform: "translateY(-50%)",
                                  color: "#6c757d",
                                  cursor: "pointer",
                                }}
                                onClick={handleOpenDialog}
                              ></i>
                            </div>
                          </Col>
                        </Row>
                        {/* <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label htmlFor="notes">Notes</label>
                          </Col>
                          <Col xl={9}>
                            <InputTextarea
                              id="notes"
                              value={notes}
                              onChange={e => setNotes(e.target.value)}
                              rows={3}
                              cols={30}
                              className="w-full"
                              placeholder="Enter notes"
                              style={{ resize: "none" }}
                            />
                          </Col>
                        </Row> */}
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col xl={6}>
              <Card className="bg-form">
                <CardBody>
                  <h4 className="card-title mb-2">System Fields</h4>
                  <Row>
                    <Col xl={12}>
                      <div>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label>Create Date</label>
                          </Col>
                          <Col xl={9}>
                            <Calendar
                            value={createdAt}
                              dateFormat="dd/mm/yy"
                              className="w-full"
                              disabled
                              showIcon
                              icon="pi pi-calendar"
                            />
                          </Col>
                        </Row>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label>Edit Date</label>
                          </Col>
                          <Col xl={9}>
                            <Calendar
                            value={updatedAt}
                              dateFormat="dd/mm/yy"
                              className="w-full"
                              placeholder="N/A"
                              disabled
                              showIcon
                              icon="pi pi-calendar"
                            />
                          </Col>
                        </Row>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label>Created By</label>
                          </Col>
                          <Col xl={9}>
                            <InputText
                              value={createdBy}
                              className="w-full"
                              disabled
                            />
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/* <Row className="align-items-center mb-3">
            <Col md={12}>
              <div className="d-flex justify-content-end">
                
                  <Button color="success" className="me-2" onClick={handleEditContact}>
                    <i className="pi pi-save me-1"></i> Save
                  </Button>
                
                  <Button color="primary" className="btn btn-primary me-2 cancel-outlinebtn" onClick={handleCancel}>
                    <i className="pi pi-times me-1"></i> Cancel
                  </Button>
                
              </div>
            </Col>
          </Row> */}
        </Container>
      </div>
      <Dialog
        header="Edit Address"
        className="address-popup"
        visible={visible}
        onHide={() => {
          setStreet1(initialAddressValues.street1)
          setStreet2(initialAddressValues.street2)
          setSelectedCountry(initialAddressValues.selectedCountry)
          setSelectedState(initialAddressValues.selectedState)
          setSelectedCity(initialAddressValues.selectedCity)
          setPostalCode(initialAddressValues.postalCode)
          setSelectedLabel(initialAddressValues.selectedLabel)
          setVisible(false)
        }}
        style={{ width: "30vw" }}
        breakpoints={{
          "960px": "75vw",
          "641px": "100vw",
        }}
      >
        <div className="card sidebardetails">
          <form>
            <Row className="mb-3">
              <Col lg={6}>
                <div className="p-field">
                  <label htmlFor="street1">Street 1</label>
                  <InputText
                    id="street1"
                    value={street1}
                    onChange={e => setStreet1(e.target.value)}
                    className="w-full activejobdrop"
                  />
                </div>
              </Col>
              <Col lg={6}>
                <label htmlFor="street2">Street 2</label>
                <InputText
                  id="street2"
                  value={street2}
                  onChange={e => setStreet2(e.target.value)}
                  className="w-full activejobdrop"
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col lg={6}>
                <label htmlFor="country">Country</label>
                <Dropdown
                  id="country"
                  value={selectedCountry}
                  onChange={e => setSelectedCountry(e.value)}
                  options={countries}
                  optionLabel="name"
                  filter
                  filterPlaceholder="Search Country"
                  className="w-full activejobdrop"
                  placeholder="Select a Country"
                />
              </Col>
              <Col lg={6}>
                <label htmlFor="state">State</label>
                <Dropdown
                  id="state"
                  value={selectedState}
                  onChange={e => setSelectedState(e.value)}
                  options={states}
                  optionLabel="name"
                  disabled={!selectedCountry}
                  filter
                  filterPlaceholder="Search State"
                  className="w-full activejobdrop"
                  placeholder="Select a State"
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col lg={6}>
                <label htmlFor="city">City</label>
                <Dropdown
                  id="city"
                  value={selectedCity}
                  onChange={e => setSelectedCity(e.value)}
                  options={cities}
                  optionLabel="name"
                  disabled={!selectedState}
                  filter
                  filterPlaceholder="Search City"
                  className="w-full activejobdrop"
                  placeholder="Select a City"
                />
              </Col>
              <Col lg={6}>
                <label htmlFor="postalCode">Postal Code</label>
                <InputText
                  id="postalCode"
                  value={postalCode}
                  onChange={e => {
                    const value = e.target.value
                    // Allow only digits and limit to 6 characters
                    if (/^\d{0,6}$/.test(value)) {
                      setPostalCode(value)
                    }
                  }}
                  maxLength={6}
                  placeholder="Enter Postal Code"
                  className="w-full activejobdrop"
                  pattern="[0-9]{6}"
                  inputMode="numeric" // Suggests numeric keyboard on mobile
                  onKeyPress={e => {
                    // Prevent non-digit characters
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault()
                    }
                  }}
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col lg={12}>
                <label htmlFor="label">Label</label>
                <Dropdown
                  value={selectedLabel}
                  onChange={e => setSelectedLabel(e.value)}
                  options={labels}
                  optionLabel="name"
                  placeholder="Select a Label"
                  className="w-full activejobdrop"
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Button
                  type="button"
                  color="primary"
                  className="btn btn-primary  waves-light me-2 sidebarbtn"
                  onClick={() => setVisible(false)}
                >
                  <i className="pi pi-check me-1"></i> Ok
                </Button>
              </Col>
            </Row>
          </form>
        </div>
      </Dialog>
    </React.Fragment>
  )
}

export default ContactEditForm
